import React from 'react';
import styles from './TwitchLink.module.scss';
import { ReactComponent as TwitchSVG } from '../../../assets/twitch.svg';

interface ITwitchLinkProps {
    handle?: string | null;
}

export const TwitchLink = ({ handle }: ITwitchLinkProps): React.JSX.Element => {
    if (!handle) {
        return (
            <span className={`${styles.icon} ${styles.disabled}`} title="No Twitch linked">
                <TwitchSVG />
            </span>
        );
    }

    return (
        <a
            className={`${styles.icon} ${styles.active}`}
            href={`https://www.twitch.tv/${handle}`}
            target="_blank"
            rel="noopener noreferrer"
            title={`twitch.tv/${handle}`}
            onClick={(e) => e.stopPropagation()}
        >
            <TwitchSVG />
        </a>
    );
};
